<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Categorias - Edição</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'product-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <form-product-category :productcategory="productcategory" :update="true"></form-product-category>
</span>
</template>

<script>
import FormProductCategoryComponent from "./partial/FormProductCategoryComponent";

export default {
    name: "AddProductCategoryComponent",
    created() {
        this.loadProductCategory()
    },
    props: {
        prod_c_id: {
            require: true
        }
    },
    data() {
        return {
            productcategory: {
                prod_c_id: '',
                prod_c_nome: '',
                prod_c_slug: '',
                prod_c_descricao: '',
                prod_c_logo: '',
                prod_c_banner: '',
                prod_c_status: false,
            },
            upload: null,
            fileName: 'Selecione uma foto',
            preview: null,
            langs: true
        }
    },
    methods: {
        loadProductCategory() {
            this.$store.dispatch('loadProductCategory', this.prod_c_id)
                .then(response => this.productcategory = response)
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        formProductCategory: FormProductCategoryComponent
    }
};
</script>

<style scoped>

</style>
